import { Action, createReducer, createSelector, on } from '@ngrx/store';

import {
  loadEditionsMetaData,
  loadEditionsMetaDataComplete,
  loadEditionsMetaDataFailure
} from 'search/full-card/actions/editions.metadata.actions';
import { EditionMetaData } from 'search/full-card/models/edition';
import { FullCardState } from 'search/full-card/reducers/full-card.reducer';
import { selectFullCard } from 'search/full-card/reducers/showcases.reducer';

export interface EditionsMetaDataState {
  error?: string;
  loading: boolean;
  data?: EditionMetaData;
}

// @ts-ignore
export const editionsMetaDataInitialState: EditionsMetaDataState = {
  error: '',
  loading: false,
  data: null,
};

const reducer = createReducer(
  editionsMetaDataInitialState,
  on(loadEditionsMetaData, (state) => ({
    ...state,
    error: '',
    loading: true,
  })),
  on(loadEditionsMetaDataComplete, (state, {data}) => {
    return {
      ...state,
      error: '',
      loading: false,
      data
    };
  }),
  on(loadEditionsMetaDataFailure, (state , payload) => ({
    ...state,
    error: payload,
    loading: false,
  })),
);

export function editionMetaDataReducer(state: EditionsMetaDataState | undefined, action: Action) {
  return reducer(state, action);
}

export const selectEditionMetaData = createSelector(
  selectFullCard,
  (state: FullCardState): EditionsMetaDataState => state.editionsMetaData,
);

export const selectMetaData = createSelector(
  selectEditionMetaData,
  (state: EditionsMetaDataState): EditionMetaData => state?.data,
);

export const selectMetaDataLoading = createSelector(
  selectEditionMetaData,
  (state: EditionsMetaDataState): boolean => state.loading,
);
